import { useEffect, useCallback } from 'react';

/**
 * Hook pour synchroniser les actions entre les fenêtres/onglets
 * Utilise localStorage pour communiquer entre les instances
 */
function useCrossWindowSync(eventName, onEvent) {
  // Écouter les événements de synchronisation
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === `sync_${eventName}` && e.newValue) {
        try {
          const eventData = JSON.parse(e.newValue);
          onEvent(eventData);
        } catch (err) {
          console.warn('Erreur parsing sync event:', err);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [eventName, onEvent]);

  // Fonction pour envoyer un événement de synchronisation
  const triggerSync = useCallback((data) => {
    const eventData = {
      ...data,
      timestamp: Date.now(),
      source: 'cross-window-sync'
    };
    
    // Utiliser localStorage pour déclencher l'événement dans les autres fenêtres
    localStorage.setItem(`sync_${eventName}`, JSON.stringify(eventData));
    
    // Nettoyer après un court délai
    setTimeout(() => {
      localStorage.removeItem(`sync_${eventName}`);
    }, 1000);
  }, [eventName]);

  return { triggerSync };
}

export default useCrossWindowSync;

